import React, { useEffect } from "react"
import { Forms } from "../../common/components/CmForms"
import OpenModalButton from "../../common/components/openModalButton"
import { ApparecchioCategory, ApparecchioFamily, CreateRapportoControlloDto, ICreateRapportoControlloDto, ImpiantoLight, RapportoControlloTypeDto } from "../../generated"
import { links } from "../../routes"
import RapportiControlloActions from "../RapportiControlloActions"
import { RapportiControlloImpiantoTable } from "./RapportiControlloImpiantoTable"
import * as Yup from 'yup';
import { InterventiSelector } from "../../interventi/components/InterventiSelector"
import RapportiControlloStore from "../RapportiControlloStore"
import InterventiStore from "../../interventi/interventiStore"
import DatesHelper from "../../common/datesHelper"
import InterventiActions from "../../interventi/InterventiActions"
import ImpiantiClienteStore from "../../impianti/ImpiantiClienteStore"
import { withApparecchioCateogories } from "../../impianti/withApparecchioCategories"
import { Dictionary } from "../../common/AbstractStores"

export const RapportoControlloModalSelector: React.FunctionComponent<{ idCliente: number, idImpianto: number, className?: string, style?: React.CSSProperties, iconClassName?: string }>
    = ({ idImpianto, idCliente, className, style, iconClassName }) => {
        const impianto = ImpiantiClienteStore.use(idCliente, idImpianto);
        if (impianto == null)
            return null;

        return <OpenModalButton
            className={className || "btn btn-outline-secondary"}
            header="Seleziona tipo rapporto controllo"
            style={style}
            modalContent={
                <RapportoControlloForm impianto={impianto} />
            }>
            <i className={iconClassName || "fas fa-print"} /> Rapp. Controllo
        </OpenModalButton >
    }



const { Form, FormInteger, FormDate, Submit } = Forms<ICreateRapportoControlloDto>();

const RapportoControlloForm = withApparecchioCateogories((props: { impianto: ImpiantoLight, categories: Dictionary<ApparecchioCategory> }) => {
    const { impianto } = props;
    const idCliente = impianto.idCliente;
    const idImpianto = impianto.id;

    const [lastNumber, setLastNumber] = React.useState<number | null>(null);
    const getLastNumber = async () => {
        const lastNumber = await RapportiControlloActions.getLastNumber(new Date().getFullYear());
        setLastNumber(lastNumber + 1);
    }

    const validationSchema = Yup.object<Partial<ICreateRapportoControlloDto>>({
        number: Yup
            .number()
            .required('Campo obbligatorio'),
        rapportoDate: Yup
            .date()
            .required('Campo obbligatorio'),
        // .test("exists", "Numero rapporto già inserita nel sistema", async value => {
        //     const l = Yup.ref("rapportoDate");
        //     console.log(l);
        //     return !await RapportiControlloActions.numberExist(new Date().getFullYear(), value)
        // }),
    })

    useEffect(() => {
        getLastNumber();
    });

    const rapporti = RapportiControlloStore.useForImpianto(impianto.id);
    const interventi = InterventiStore.useForCliente(impianto.id);
    if (!rapporti || !interventi)
        return null;

    const impiantoFamily = props.categories[impianto.type]!.family;

    const generateRapportoDiControllo = async (dto: ICreateRapportoControlloDto) => {
        const year = dto.rapportoDate.getFullYear();
        const number = dto.number!;
        if (!await RapportiControlloActions.numberExist(year, number!)) {
            if (dto.idIntervento == null) {
                const interventiImpianto = interventi.filter(x => x.idImpianto == dto.idImpianto);
                const compatibleIntervento = interventiImpianto.find(x => DatesHelper.differenceInDays(dto.rapportoDate, x.dataIntervento).days <= 2 && x.controlloCombustione && x.rapportoControlloId == null)
                if (compatibleIntervento) {
                    dto.idIntervento = compatibleIntervento.idIntervento;
                }
            }

            const alreadyExistRapporto = rapporti.find(x => x.idIntervento != null && x.idIntervento == dto.idIntervento);
            if (alreadyExistRapporto != null) {
                alert(`Attenzione esiste già il rapporto ${alreadyExistRapporto.nrRapporto} collegato all'intervento id ${dto.idIntervento}`);
                return;
            }

            const data = new CreateRapportoControlloDto(dto);
            const result = await RapportiControlloActions.create(data);
            await RapportiControlloActions.getByIdImpianto(dto.idImpianto);
            if (data.idIntervento) {
                InterventiActions.getByCustomer(impianto.idCliente);
            }
            window.open(links.rapportoControllo(result.year, result.number, dto.type), "_blank");
        }
        else {
            alert(`Attenzione il rapporto controllo ${number}/${year} esiste già! Utilizzare un progressivo ancora non utilizzato.`)
        }
    }

    const openEmpty = async (idImpianto: number, type: RapportoControlloTypeDto) => {
        if (confirm(`Attenzione, con questa funzionalità verrà generato solamente il modello precompilato senza nessuna possibilità di salvataggio e senza poterlo visualizzare nello storico rapporti di controllo.
Per utilizzare al meglio le funzionalità del programma si consiglia di utilizzare l'apposito tasto "Genera rapporto di controllo" sotto.
Sei sicuro di voler procedere?`)) {
            window.open(links.rapportoControlloEmpty(idImpianto, type), "_blank");
        }
    }

    const getDefault = () => {
        switch (impiantoFamily) {
            case ApparecchioFamily.ClimatizzazioneElettrico:
                return RapportoControlloTypeDto.Frigo;
            case ApparecchioFamily.Biomassa:
                return RapportoControlloTypeDto.BiomassaStandard;
            default:
                return RapportoControlloTypeDto.Standard;
        }
    }

    if (!lastNumber)
        return null;

    return <Form
        onSubmit={generateRapportoDiControllo}
        validationSchema={validationSchema}
        initialValues={{
            idImpianto: impianto.id,
            type: getDefault(),
            number: lastNumber,
            idIntervento: undefined,
            rapportoDate: new Date()
        }}
        noPrompt
    >
        {({ set, values, errors }) =>
            <div className="row">
                <div className="col-12 mb-3">
                    <div className="d-flex w-100">
                        <RapportoControlloTypeSelector
                            value={values.type}
                            onChange={typeId => set("type", typeId)}
                            family={impiantoFamily}
                        />
                        <button className="btn btn-outline-secondary align-self-end ms-auto me-1 d-flex align-items-center"
                            type="button"
                            onClick={() => openEmpty(idImpianto, values.type)}
                            style={{ height: 38 }}                            >
                            <span style={{ whiteSpace: "nowrap" }}><i className="far fa-file" /> Solo Modello</span>
                        </button>
                    </div>
                </div>
                <div className="col-12">
                    {rapporti.length > 0 &&
                        <>
                            <h4 className="badge bg-secondary text-white" style={{ fontSize: "1rem" }}>
                                Apri un rapporto salvato
                            </h4>
                            <RapportiControlloImpiantoTable
                                rapporti={rapporti}
                                idCliente={idCliente}
                                onSelect={data => window.open(links.rapportoControllo(data.year, data.number, values.type), "_blank")}
                                onDelete={async item => {
                                    if (await confirm(`Sei sicuro di voler eliminare l'allegato ${item.year}/${item.number}?`)) {
                                        await RapportiControlloActions.delete(item.idImpianto, item.year, item.number)
                                        await InterventiActions.getByCustomer(idCliente)
                                    }
                                }}
                            />
                        </>
                    }
                </div>
                <div className="col-12 fw-bold">
                    <h4 className="badge bg-secondary text-white" style={{ fontSize: "1rem" }}>
                        {rapporti.length == 0 ? "Genera e salva un nuovo rapporto di controllo" : "Oppure genera e salva uno nuovo"}
                    </h4>
                </div>
                <div className="col-12 col-md-6">
                    <InterventiSelector
                        label="Seleziona intervento di controllo"
                        idCliente={idCliente}
                        filter={x => x.idImpianto == idImpianto && (x.controlloCombustione || x.controlloStandard) && x.rapportoControlloId == null}
                        value={values.idIntervento ?? null}
                        onChange={async intervento => {
                            await set("idIntervento", intervento?.idIntervento)
                            await set("rapportoDate", intervento?.dataIntervento ?? new Date())
                        }}
                        allowNull
                    />
                </div>
                <div className="col-12 col-md-6">
                    <FormDate
                        label="Data rapporto"
                        name="rapportoDate"
                        readOnly={values.idIntervento != null}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <FormInteger
                        label="Progressivo rapporto"
                        type="number"
                        name="number"
                    />
                </div>
                <div className="col-12 mt-4">
                    <Submit alwaysActive>
                        <i className="fas fa-print button-success" /> Genera Rapporto controllo
                    </Submit>

                </div>
            </div>
        }
    </Form>
})(x => x.allByKey(), "categories")

export const RapportoControlloTypeSelector: React.FC<{ value: number, onChange: (value: number) => void, family: ApparecchioFamily }> = ({ value, onChange, family }) => {
    const data: { id: number, description: string, family: ApparecchioFamily }[] = family == ApparecchioFamily.ClimatizzazioneElettrico
        ? [
            { id: RapportoControlloTypeDto.Frigo, description: "Rapporto di controllo Nazionale (GRUPPI FRIGO)", family: ApparecchioFamily.ClimatizzazioneElettrico }
        ]
        : [
            { id: RapportoControlloTypeDto.Standard, description: "Rapporto di controllo Nazionale", family: ApparecchioFamily.Idrotermico },
            { id: RapportoControlloTypeDto.Lombardia, description: "Rapporto di controllo Regione Lombardia", family: ApparecchioFamily.Idrotermico },
            { id: RapportoControlloTypeDto.Piemonte, description: "Rapporto di controllo Regione Piemonte", family: ApparecchioFamily.Idrotermico },
            { id: RapportoControlloTypeDto.BiomassaStandard, description: "Rapporto di controllo Biomasse Nazionale", family: ApparecchioFamily.Biomassa }
        ]
    return <div className="w-100">
        <label className="form-label">Formato rapporto controllo</label>
        <select className="form-control text-uppercase"
            onChange={(e) => onChange(parseInt((e.target as any).value))}
            value={value}>
            {data.map(x => <option value={x.id} key={x.id}>{x.description}</option>)}
        </select>
    </div>

}